export const KEY_CODES = {
  backspace: 8,
  tab: 9,
  return: 13,
  alt: 18,
  esc: 27,
  space: 32,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  r: 82,
  l: 76,
};

export const KEYS = {
  BACKSPACE: 'Backspace',
};
